// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"49519b56","866":"d29b966c"}[chunkId] + ".chunk.js";
};